import React from "react"
import PropTypes from "prop-types"
import MuiList from '@material-ui/core/List';

import { withStyles } from "@material-ui/core/styles"
import classnames from "classnames"

export const styleSheet = theme => ({
  root: {
    backgroundColor: "inherit",
  },

  extendGutters: {
    [theme.breakpoints.up("sm")]: {
      marginLeft: theme.spacing.unit * -1,
      marginRight: theme.spacing.unit * -1,

      "& > li, & > div > li": {
        paddingLeft: theme.spacing.unit * 4,
        paddingRight: theme.spacing.unit * 4,
      },
    },

    [theme.breakpoints.up("md")]: {
      marginLeft: theme.spacing.unit * -3,
      marginRight: theme.spacing.unit * -3,

      "& > li, & > div > li": {
        paddingLeft: theme.spacing.unit * 6,
        paddingRight: theme.spacing.unit * 6,
      },
    },
  },
})

function List({ classes, className: classNameProp, extendGutters, ...otherProps }) {
  const className = classnames(
    classes.root,
    { [classes.extendGutters]: extendGutters },
    classNameProp
  )

  return <MuiList {...otherProps} className={className} />
}

List.propTypes = {
  extendGutters: PropTypes.bool,
}

List.muiName = List.muiName

export default withStyles(styleSheet)(List)



// WEBPACK FOOTER //
// ../ui-kit/src/components/ui-List/List.js